// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ServiceFiscalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/service_fiscal/get/{service_id}
 *
 * `fiscal` is null when neither a franchise-specific nor a global fiscal
 * row exists for the service at all.
 */
import type { So_ServiceFiscalEffectiveRow } from './So_ServiceFiscalEffectiveRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_ServiceFiscalResponseDados = So_ServiceFiscalEffectiveRow;

export type So_ServiceFiscalResponse = ApiResponse<So_ServiceFiscalResponseDados>;

registerResponseContract('So_ServiceFiscalResponse', {
  _nullable:                                    { type: 'boolean', required: false },
  so_service_id:                                { type: 'number',  required: true },
  franchise_id:                                 { type: 'number',  required: false },
  is_override:                                  { type: 'boolean', required: true },
  is_configured:                                { type: 'boolean', required: true },
  so_service_fiscal_lc116_code:                 { type: 'string',  required: false },
  so_service_fiscal_municipal_service_code:     { type: 'string',  required: false },
  so_service_fiscal_iss_aliquota:               { type: 'number',  required: false },
  so_service_fiscal_iss_retido_default:         { type: 'number',  required: false },
  so_service_fiscal_municipio_incidencia_ibge:  { type: 'string',  required: false },
  so_service_fiscal_cnae:                       { type: 'string',  required: false },
  so_service_fiscal_codigo_tributacao_nacional: { type: 'string',  required: false },
})
